import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, MapPin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-col">
            <h3>Maître Dia</h3>
            <p className="footer-description">
              Grand marabout africain à Bruxelles. Services de voyance, 
              médiumnité et accompagnement spirituel disponibles 24/7.
            </p>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <div className="footer-contact">
              <div className="contact-item">
                <Phone size={18} />
                <span>04 65 61 94 11</span>
              </div>
              <div className="contact-item">
                <MapPin size={18} />
                <span>Avenue Louise 250, 1050 Bruxelles</span>
              </div>
            </div>
          </div>

          <div className="footer-col">
            <h4>Communes de Bruxelles</h4>
            <ul className="footer-links">
              <li>Bruxelles-Centre</li>
              <li>Ixelles</li>
              <li>Schaerbeek</li>
              <li>Anderlecht</li>
              <li>Molenbeek</li>
              <li>Uccle</li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Navigation</h4>
            <ul className="footer-links">
              <li><Link to="/">Accueil</Link></li>
              <li><a href="/#about">À propos</a></li>
              <li><a href="/#services">Services</a></li>
              <li><Link to="/temoignages">Témoignages</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">
            &copy; {currentYear} Maître Dia - Marabout Bruxelles. Tous droits réservés.
          </p>
          <div className="social-links">
            <a href="#" aria-label="Facebook">
              <Facebook size={20} />
            </a>
            <a href="#" aria-label="Instagram">
              <Instagram size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
